import axios from "axios";
import SettingsAplications from '@/core/settingsCoreAplications';
import { useAuthorization } from '@/stores/AuthorizationStore';
import { useErrorStore } from '@/stores/ErrorStoreServer';
import router from '@/router';

const Permissions = new SettingsAplications();
const _urlPublic = Permissions.endPointMain.core.name;

export interface IresponseAuth {
  success: boolean;
  message: string;
  content: {};
  statusCode: boolean;
  accessToken: string;
  expiresOn: string;
  refreshToken: string;
}

const isPublicUrl = (url: string) => {
  return (
    url.includes("https://api.ipify.org/?format=json") ||
    url.includes("/apiwebservices") ||
    url === _urlPublic + "/printer-statuses" ||
    url === _urlPublic + "/login" ||
    url === _urlPublic + "/refresh-token"
  );
};

export const AxiosInterceptor = () => {
  const date = new Date();
  axios.interceptors.request.use(async (config) => {
    const storeAuth = useAuthorization();
    const statusToken = storeAuth.getStatusToken;
    let accessToken = storeAuth.getToken;
    let expiredOn = new Date(storeAuth.getExpiredOn);

    const statusCode = storeAuth.getStatusCode;

    if (isPublicUrl(config.url || "")) return config;

    if (statusToken && date < expiredOn) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    } else if (statusToken && date > expiredOn) {
      const resRefresh = await storeAuth.auhtAplicationRefresh();
      if (resRefresh.StatusCode === 200) {
        storeAuth.setResponseToken(
          resRefresh.AccessToken,
          resRefresh.RefreshToken,
          resRefresh.ExpiresOn
        );
        accessToken = resRefresh.AccessToken;
        expiredOn = new Date(resRefresh.ExpiresOn);
        config.headers.Authorization = `Bearer ${accessToken}`;
      } else {
        storeAuth.setTokens();
      }
    } else {
      storeAuth.expulseAplication("Application Invalid Request " + statusCode);
    }

    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      if (isPublicUrl(response.request.responseURL)) return response;

      if ([901, 902, 910, 912].includes(response.data.StatusCode)) {
        useAuthorization().expulseAplication(
          `Application Invalid Response: ${response.data.StatusCode} ${response.data.Message}`
        );
        document.location.href = '/Auth/Login';
      }

      return response;
    },
    (error) => {
      if (error.response && error.response.status === 500) {
        const requestUrl = error.response.config?.url || '';
       
        const ignoredOperations = ['CambioNIP', 'Egreso', 'Reingreso', 'Traslado','ActualizarCuentaIDTelefonico'];
        const branchPattern = /(BCN|MTY|SON)/; 

        const shouldIgnore = ignoredOperations.some((op) =>
          new RegExp(
            `/apiwebservices/${branchPattern.source}/${branchPattern.source}_WS.asmx\\?op=${op}`
          ).test(requestUrl)
        );

        if (shouldIgnore) {
          return;
        }
      
        const errorStore = useErrorStore();
        const message =
          error.response?.data?.message ||
          error.message ||
          'Ocurrió un error inesperado en el servidor';

        errorStore.setMessage(message);
        router.push({ name: 'ServerError' });
      }

      return Promise.reject(error);
    }
  );
};
